<div class="card shadow-sm border-0 br-9" [ngClass]="customClasses">
  <ng-content></ng-content>
</div>